import React from 'react'
// import { Document, Page } from 'react-pdf'
import { Document, Page } from 'react-pdf/dist/entry.webpack'

import styles from './ReportFile.css'
import ContentHeader from '../../containers/ContentHeader'
import { HEADER_HEIGHT, SCROLLBAR_WIDTH, BOTTOM_PADDING, AUTHORIZATION_TYPES } from '../../constants'
import EcgLoader from '../../containers/EcgLoader'
import ESignIcon from 'static/images/icons/pen.svg'
import CancelIcon from 'static/images/icons/block.svg'
import NextArrowIcon from 'static/images/next-arrow.svg'
import Exportedicon from 'static/images/exported.svg'
// import SignatureIcon from 'static/images/signature.svg'
import Popover from '../../containers/Popovers/components/Popover'
import { ESIGN_STEPS, checkIsSigned } from './module'
import { needToBustCache } from '../../store/appReducer'

class ReportFile extends React.Component {
  state = {
    numPages: null,
    innerHeight: 0,
    // innerWidth: 0,
  }

  UNSAFE_componentWillMount() {
    const {
      match,
      dataLastUpdated,
      updateSelectedReportId,
      getReportFileData,
      getPrerequisiteData,
    } = this.props
    const {
      reportId,
    } = match.params
    updateSelectedReportId(reportId)
    getReportFileData(needToBustCache(dataLastUpdated), getPrerequisiteData)

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages })
  }

  docRef = React.createRef()

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      // innerWidth: window.innerWidth,
    })
  }

  handleOnAllReportsClick = () => {
    const {
      handleOnAllReportsRedirect,
    } = this.props
    if (typeof handleOnAllReportsRedirect === 'function') {
      handleOnAllReportsRedirect()
    }

    this.props.handleOnAllReportsClick()
  }

  handleOnRefreshClick = () => {
    const {
      getReportFileData,
      getPrerequisiteData,
    } = this.props

    this.setState({
      numPages: null,
    })

    return getReportFileData(true, getPrerequisiteData)
  }

  renderPages = ({ height, width }) => {
    const {
      numPages,
    } = this.state

    const pages = []

    for (let pageNum = 1; pageNum <= numPages; pageNum += 1) {
      pages.push(<Page
        key={pageNum}
        pageNumber={pageNum}
        width={width}
        scale={this.PAGE_SCALE}
        className={styles.page}
        loading=" "
      />)
    }

    return pages
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      getPrerequisiteData,
      authorizationType,
      browser,
      tempComment,
      esignStep,
      selectedPopover,
      selectedReportId,
      singleReportPdf,
      handleOnCommentChange,
      handleOnCancelClick,
      handleOnSignatureClick,
      handleOnEsignClick,
      handleOnOutsidePopoverClick,
      handleOnPatientClick,
      reports,
      showViewPatientOption,
    } = this.props
    const {
      innerHeight,
    } = this.state

    const height = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING
    const width = 1180 - (20 * 2)
    const scrollbarWidth = browser && browser.name === 'ie'
      ? SCROLLBAR_WIDTH
      : 7
    const pdfWidth = width - scrollbarWidth

    let report
    let esigned

    if (reports.data && singleReportPdf.data && singleReportPdf.data.id === selectedReportId) {
      report = reports.data.byId[selectedReportId]
      esigned = checkIsSigned(report)
    }

    const esignClassname = esigned ? styles.esignedButton : styles.esignButton

    return (
      <div data-page="report-file" className={styles.reportFile}>
        <ContentHeader
          text="Report"
          hasTabs
          isLoading={dataIsFetching}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={() => this.handleOnRefreshClick()}
          showAddPatient={authorizationType !== AUTHORIZATION_TYPES.EPIC}
          enableBackButton={true}
        />
        <div className={styles.esignWrapper}>
          <div className={styles.popoverWrapper}>
            <button
              className={esignClassname}
              onClick={() => !dataIsFetching && !esigned && handleOnEsignClick(getPrerequisiteData)}
              disabled={dataIsFetching || esigned}
              data-action="esign"
            >
              <ESignIcon className={styles.eSignIcon} />
              {esigned
                ? 'E-signed'
                : 'E-sign'
              }
            </button>
          </div>
          {selectedPopover &&
            <Popover
              className={styles.popover}
              onOutsidePopoverClick={handleOnOutsidePopoverClick}
            >
              {esignStep === ESIGN_STEPS.COMMENT_AND_ESIGN &&
                <React.Fragment>
                  <textarea
                    value={tempComment}
                    className={styles.textArea}
                    placeholder="Provider comments ..."
                    onChange={e => handleOnCommentChange(e.target.value)}
                  />
                  <div className={styles.esignControls}>
                    <button
                      className={styles.cancelButton}
                      onClick={() => handleOnCancelClick()}
                    >
                      <CancelIcon className={styles.cancelIcon} />
                      Cancel
                    </button>
                    <button
                      className={styles.signatureButton}
                      onClick={() => handleOnSignatureClick()}
                    >
                      {/* <ESignIcon className={styles.signatureIcon} /> */}
                      Signature
                    </button>
                  </div>
                </React.Fragment>
              }
              {esignStep === ESIGN_STEPS.REPORT_ESIGNED &&
                <React.Fragment>
                  <div className={styles.esigned}>
                    <h1 className={styles.esignedTitle}>Report <span>Signed</span></h1>
                    <Exportedicon className={styles.exportedIcon} />
                  </div>
                  <button
                    className={styles.allReportsButton}
                    onClick={this.handleOnAllReportsClick}
                  >
                    <NextArrowIcon className={styles.nextArrowIcon} />
                    All Reports
                  </button>
                </React.Fragment>
              }
            </Popover>
          }
        </div>
        <div
          className={styles.viewPatient}
        >
          {report && !dataIsFetching && showViewPatientOption
            && (
              <button
                data-action="view-patient-file"
                className={styles.viewPatientButton}
                onClick={() => handleOnPatientClick(true, true, { patientId: report.participantId, referral: 'reportFile' })}
              >
                View Patient File
              </button>
            )
          }
        </div>
        <div
          ref={this.docRef}
          className={styles.documentWrapper}
          style={{
            height,
            width,
          }}
        >
          {report
            ? (
              <Document
                file={report.blob}
                noData={
                  <div
                    className={styles.contentWrapper}
                    style={{
                      height,
                    }}
                  >
                    <EcgLoader />
                  </div>
                }
                loading={
                  <div
                    className={styles.contentWrapper}
                    style={{
                      height,
                    }}
                  >
                    <EcgLoader />
                  </div>
                }
                onLoadSuccess={this.onDocumentLoadSuccess}
              >
                {this.renderPages({ height, width: pdfWidth })}
              </Document>
            )
            : (
              <div
                className={styles.contentWrapper}
                style={{
                  height,
                }}
              >
                <EcgLoader />
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default ReportFile



// WEBPACK FOOTER //
// ./src/legacy/containers/ReportFile/ReportFile.jsx